import { OrgUser } from 'src/types';

export const filterOrgUsers = (
  searchQuery: string,
  userList: OrgUser[]
): OrgUser[] =>
  userList.filter((user) => {
    const userFullName = `${user.firstName} ${user.lastName}`;

    return (
      userFullName.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
      user.email?.toLowerCase().includes(searchQuery.toLowerCase().trim())
    );
  });
